import FilterTextField from '../baseInputTypes/FilterTextField'

export const MediaNumber = () => (
  <FilterTextField
    label="Media Number"
    fieldPath={'documentInformation.mediaNumber'}
  />
)
